<template>
  <div style="text-align: center">
    <p class="my_title">{{ name }} ({{ mbti }})</p>
    <p class="my_subtitle">{{ title }}</p>
    <div v-for="(item, index) in contents" :key="index">• {{ item }}</div>
  </div>
</template>

<script>
import MbtiCommon from "./../scripts/MbtiCommon";
export default {
  data: function () {
    return {
      mbti: "",
      contents: [],
      name: "",
      title: "",
    };
  },
  methods: {
    addDirectly() {
      this.$emit("showMbtiMakePopup");
    },
    setMbti(mbti, name) {
      this.mbti = mbti;
      this.name = name;
      let mbtiContent = MbtiCommon.getMbtiContents(this.mbti);
      this.contents = mbtiContent.contents;
      this.title = mbtiContent.title;
    },
    dismiss() {
      this.$emit("dismiss");
    },
  },
};
</script>

<style scoped>
.my_title {
  font-size: 1.2rem;
  text-align: center;
  color: #333333;
}

.my_subtitle {
  font-size: 1rem;
  text-align: center;
  color: #06a5a5;
}
</style>
